import { useQuery } from 'react-query'
import styled from 'styled-components'
import { t } from 'ttag'
import PropTypes from 'prop-types'

import { api } from '@h2/api'
import { Heading } from '@h2/components/typography/heading'
import { Text } from '@h2/components/typography/text'
import { Flex } from '@h2/components/layout/flex'
import { Box } from '@h2/components/layout/box'
import { FeedIcon } from '@h2/components/icons/feed'
import { Headed2LogoChevronIcon } from '@h2/components/icons/headed2LogoChevron'
import { Notification } from '@h2/common/components/header/navigation/notification'
import { Link } from '@h2/common/components/link'

import { FeedList } from './feedList'

const HeadingWrap = styled(Flex)`
  align-items: center;
  margin-bottom: 5px;
  > :first-child {
    margin-left: 5px;
  }
  flex-wrap: wrap;
`
const IconWrap = styled(Flex)`
  position: relative;

  > :nth-child(2) {
    top: 0;
  }
`
const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  margin-left: auto;
`
const Feed = ({ maxItems = 10 }) => {
  const { data: feed, isFetching } = useQuery(['feed', maxItems], () =>
    api.fetch('/feed', { method: 'POST', body: JSON.stringify({ maxItems }) })
  )
  const items = feed?.items || []

  return (
    <Box width="100%">
      <HeadingWrap>
        <IconWrap>
          <FeedIcon />
          {feed?.messageCount > 0 && <Notification count={feed.messageCount} />}
        </IconWrap>

        <Heading level="4" ml="5px" mb="0">
          {t`Feed`}
        </Heading>
        <StyledLink href="/messaging">
          <Text margin="0 5px 0 0" weight="bold" size="medium">
            {t`View All`}
          </Text>
          <Headed2LogoChevronIcon size="tiny" />
        </StyledLink>
      </HeadingWrap>
      <FeedList items={items} isFetching={isFetching} />
    </Box>
  )
}

Feed.propTypes = {
  maxItems: PropTypes.number
}

export { Feed }
